const translations = {
    'age.label': 'Wiek %d',
};

export default translations;
